import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import apiService from "../../../Services/authenticationServices";
import { useB2cOrders } from "./B2cOrders";
import { toast } from "react-toastify";
import b2bService from "../../../Services/b2bServises";
import { convertUTCDate } from "../../../Utils/utilServices";


const OrderHeaderAccordion = ({
  data,
  index,
  isOpen,
  onToggle,
  selectedItems,
  onSelectItem,
  isConsignmentMode,
  onClose
}) => {
  const scrollRef = useRef(null);
  const bgColor = index % 2 === 0 ? "bg-[#f6f5f1]" : "bg-[#FFFFFF]";
  const [orderDetails, setOrderDetails] = useState([]);


  const slaList = [
    { name: '0 -12 Hours', value: 1 },
    { name: '12-24 Hours', value: 2 },
    { name: '24-36 Hours', value: 3 },
    { name: '36-48 Hours', value: 4 },
    { name: '48-60 Hours', value: 5 },
    { name: '60-72 Hours', value: 6 },
    { name: '72 Hrs-1 Week', value: 7 },
    { name: 'Cannot be supplied', value: 8 },
    { name: 'CureBay Preferred Medicine ', value: 9 },
  ];

  const columns = [
    { field: 'drugName', header: 'Drug Name' },
    { field: 'drugCode', header: 'Drug Code' },
    { field: 'drugsInfoComposition', header: 'Composition & Strength' },
    // { field: 'drugsInfoTypeofsell', header: 'Package Size' },
    { field: 'quantity', header: 'Quantity' },
    { field: 'unitPrice', header: 'Unit Price' },
    { field: 'actualPrice', header: 'Payable Amount' },
    { field: 'reason', header: 'Pdt.Status' },
    // { field: 'deliverySla', header: 'SLA' },
    // { field: 'deliverySlaTime', header: 'Committed ETA' },
    // { field: 'deliverySlaETATime', header: 'ETA' },
    // { field: 'remarks', header: 'Remarks' },
  ];

  const pdtStatuses = [
    { name: 'Yet to Packed', value: '' },
    { name: 'Packed', value: 1 },
    { name: 'Shipped', value: 2 },
    { name: 'Order on the Bus', value: 3 },
    { name: 'Out for Delivery', value: 4 },
    { name: 'Delivered', value: 5 }
  ];



  const formatAddress = (...parts) => parts.filter(Boolean).join(", ");

  const fetchData = async () => {
    try {
      const payload = {
        patientDrugPrescriptionOrderId: data.orderId,
        status: 1,
      };
      const response = await apiService.getOrderDetails(payload);
      setOrderDetails(response.data.successList || []);
    } catch (err) {
      toast.error("An error occurred while fetching order details.");
    }
  };


  const copyConfirmTab = (item, index) => {
    const newOrderDetails = [...orderDetails];
    const copiedItem = { ...newOrderDetails[index] };

    newOrderDetails[index].disabled = true;
    newOrderDetails[index].copiedFrom = 'Y';

    copiedItem.id = null;
    copiedItem.copiedqty = copiedItem.quantity;
    copiedItem.quantity = 0;
    copiedItem.copiedindex = index;
    copiedItem.disabled = false;
    copiedItem.copiedFrom = 'N';
    newOrderDetails.push(copiedItem);
    setOrderDetails(newOrderDetails);
  };



  const headerFields = [
    {
      label: "Order Date",
      value: new Date(data.modifiedDate).toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(',', ''),
      width: "w-[45%] sm:w-[12%]"
    },
    {
      label: "Order ID",
      value: data.orderId,
      width: "w-[45%] sm:w-[12%]"
    },
    {
      label: "Patient ID",
      value: data.patientId,
      width: "w-[45%] sm:w-[12%]"
    },
    {
      label: "Patient Name",
      value: data.patientName,
      width: "w-[45%] sm:w-[12%]"
    },
    {
      label: "Mobile No.",
      value: data.patientMobile,
      width: "w-[45%] sm:w-[12%]"
    },
    {
      label: "Patient Address",
      value: formatAddress(data.deliveryAddress1, data.deliveryAddress2, data.deliveryAddress3) || data.patientAddress,
      width: "w-[45%] sm:w-[20%]"
    },
    {
      label: "Amount",
      value: data.paidAmount,
      width: "w-[45%] sm:w-[20%]"
    }
  ];

  const handleItemSelect = (item, isChecked) => {
    onSelectItem(item, isChecked, data.orderId);
  };

  useEffect(() => {
    if (isOpen) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      fetchData();
    }
  }, [isOpen, data.orderId]);

  return (
    <div ref={scrollRef} className={`border rounded ${bgColor} my-3`}>
      <div
        onClick={onToggle}
        className="cursor-pointer px-2 sm:px-4 flex justify-between items-center"
      >
        <div className="flex flex-wrap sm:flex-nowrap overflow-auto text-xs p-2 sm:p-4 gap-3 sm:gap-5">
          {headerFields.map(({ label, value, width }, i) => (
            <span key={i} className={`${width} break-words`}>
              <span className="text-gray-500">{label}:</span> {value}
            </span>
          ))}
        </div>
        <span className="text-gray-600 text-xl">
          {isOpen ? <HiChevronUp /> : <HiChevronDown />}
        </span>
      </div>

      {isOpen && <div className="h-[1px] bg-gray-300 w-full" />}

      {isOpen && (
        <div className="p-4 pb-8 bg-white overflow-auto">
          <div className="flex flex-wrap sm:flex-nowrap overflow-auto gap-2 sm:gap-4 mb-4 text-sm">
            {data.defaultSla && (
              <div className="w-full sm:w-[15%] break-words">
                <p className="text-gray-500">
                  Deliver SLA: <span>{data.defaultSla}</span>
                </p>
              </div>
            )}
            {data.shipTo && (
              <div className="w-full sm:w-[15%] break-words">
                <p className="text-gray-500">
                  Ship To: <span>{data.shipTo}</span>
                </p>
              </div>
            )}
            {data.shippingName && (
              <div className="w-full sm:w-[20%] break-words">
                <p className="text-gray-500">
                  Shipping Name: <span>{data.shippingName}</span>
                </p>
              </div>
            )}
            {data.shippingAddress && (
              <div className="w-full sm:w-[50%] break-words">
                <p className="text-gray-500">
                  Shipping Address: <span>{data.shippingAddress}</span>
                </p>
              </div>
            )}
          </div>



          <div className="overflow-x-auto border border-[#1d2f5b] rounded-md">
            <div className="min-w-full inline-block align-middle">
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left">
                  <thead className="bg-[#1d2f5b] text-white">
                    <tr>
                      {columns.map((column, index) => (
                        <th key={index} className="p-2 font-semibold">
                          {column.header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails.map((item, index) => (
                      <tr key={item.id || index} className="border-t">
                        {columns.map((column) => {

                          return (
                            <td key={column.field} className="p-2 whitespace-nowrap">
                              {item[column.field] || '-'}
                            </td>
                          );

                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const B2cCancelled = forwardRef((props, ref) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [orders, setOrders] = useState([]);
  const [invalidList, setinvalidList] = useState([]);
  const [consignmentList, setconsignmentList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isConsignmentMode, setIsConsignmentMode] = useState(false);
  const [sortOrder, setSortOrder] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(true);
  const { filter, setFilterField } = useB2cOrders();

  const handleSelectItem = (item, isChecked, orderId) => {
    if (isChecked) {
      setSelectedItems(prev => [
        ...prev,
        {
          orderId: orderId,
          orderDetailsId: item.id,
          modifiedBy: localStorage.getItem('userCode'),
          itemId: item.id,
          drugCode: item.drugCode,
          quantity: item.quantity
        }
      ]);
    } else {
      setSelectedItems(prev =>
        prev.filter(selected =>
          !(selected.orderId === orderId && selected.itemId === item.id)
        )
      );
    }
  };

  const fetchData = async (pageNo = 1) => {
    try {
      const payload = {
        procedureStatus: 7,
        pageNumber: pageNo,
        orderBy: sortOrder === 0 ? 'ASC' : 'DESC',
        orderSource: "B2C",

        ...Object.fromEntries(
          Object.entries(filter).filter(
            ([_, val]) => val !== null && val !== undefined && val !== ""
          )
        ),
      };
      if (payload.fromDate && payload.toDate) {
        payload.fromDate = convertUTCDate(payload.fromDate);
        payload.toDate = convertUTCDate(payload.toDate);
      }
      const response = await apiService.getmedicineOrders(payload);
      let orderList = response.data.successList || [];

      setOrders(orderList);
      setCurrentPage(pageNo);
      setHasNextPage(orderList.length > 0);
    } catch (err) {
      console.error("Failed to fetch orders", err);
      setOrders([]);
      setHasNextPage(false);
      toast.error("Failed to fetch orders");
    }
  };

  const handleCreateConsignment = async () => {
    if (selectedItems.length === 0) {
      toast.error("Please select at least one item to create consignment");
      return;
    }

    try {
      const response = await b2bService.createConsignment(selectedItems, 'CHE');

      if (response.statusCode === 200) {
        toast.success(response.message);
        setSelectedItems([]);
        packConsignment(response.data.consignmentId);
      } else {
        toast.error(response.message || "Failed to create consignment");
      }
    } catch (error) {
      console.error("Consignment creation error:", error);
      toast.error("Failed to create consignment");
    }
  };

  const packConsignment = async (consignmentId) => {
    if (!consignmentId) {
      toast.error('Please select consignment id');
      return;
    }

    let user = JSON.parse(localStorage.getItem('loginObj'));
    let payload = {
      "consignmentId": consignmentId,
      "statusName": "PACKED",
      "userName": user.salutation + user.firstName + user.lastName,
      "userId": localStorage.getItem('userCode'),
      "createdBy": localStorage.getItem('userCode'),
      "modifiedBy": localStorage.getItem('userCode'),
      "status": "1",
      "source": 'CHE'
    };

    try {
      const response = await apiService.packConsignment(payload);
      if (response.responseCode == '200') {
        toast.success(response?.message);
        fetchData(currentPage);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Packing error:", error);
      toast.error("Failed to pack consignment");
    }
  };

  const handleNextPage = () => {
    fetchData(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      fetchData(currentPage - 1);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, [filter, sortOrder]);

  useImperativeHandle(ref, () => ({
    onSearch: () => fetchData(1),
  }));

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const handleSortChange = (value) => {
    setSortOrder(value);
  };

  return (
    <div className="pl-1 pr-1 sm:pr-6 min-h-screen">
      <div className="flex flex-wrap items-center gap-4 ml-4 mb-4">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="newest"
            checked={sortOrder === 1}
            onChange={() => handleSortChange(1)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Newest First</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="oldest"
            checked={sortOrder === 0}
            onChange={() => handleSortChange(0)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Oldest First</span>
        </label>
      </div>



      {orders.map((order, index) => (
        <OrderHeaderAccordion
          key={index}
          data={order}
          index={index}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
          selectedItems={selectedItems}
          onSelectItem={handleSelectItem}
          isConsignmentMode={isConsignmentMode}
          onClose={fetchData}
        />
      ))}

      <div className="flex flex-wrap justify-center items-center mt-4 mb-8 gap-2">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Previous
        </button>

        <button
          onClick={() => fetchData(1)}
          className={`px-4 py-2 border rounded ${currentPage === 1 ? 'bg-blue-100' : ''}`}
        >
          1
        </button>

        {currentPage > 1 && (
          <button
            onClick={() => fetchData(currentPage)}
            className="px-4 py-2 border rounded bg-blue-100"
          >
            {currentPage}
          </button>
        )}

        <button
          onClick={handleNextPage}
          disabled={!hasNextPage}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
});



export default B2cCancelled;

